export default __webpack_public_path__ + "static/media/basketIcon.4df1a1f6.svg";